import { SMS_TRACKING_PERIODS, SMS_TRACKING_STATUSES } from '@gozoki/api-types'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { AuthorizedAppButton } from '~/components/new/buttons/authorized-button'
import {
  SMS_RESEND,
  SMS_SENT_EXPORT,
  SMS_SENT_READ,
} from '~/components/routes/hr/sms-tracking/permissions'
import { SmsTrackingExportDialog } from '~/components/routes/hr/sms-tracking/sms-tracking-export-dialog'
import { SmsTrackingPage } from '~/components/routes/hr/sms-tracking/sms-tracking-page'
import { SmsTrackingRelaunchDialog } from '~/components/routes/hr/sms-tracking/sms-tracking-relaunch-dialog'
import { withRoutePermissions } from '~/utils/rbac'

const searchSchema = z.object({
  period: z.enum(SMS_TRACKING_PERIODS).optional(),
  storeId: z.number().int().positive().optional(),
  status: z.enum(SMS_TRACKING_STATUSES).optional(),
  search: z.string().optional(),
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().positive().optional(),
})

export const Route = createFileRoute('/_authenticated/hr/sms-tracking')({
  validateSearch: searchSchema,
  staticData: { permission: SMS_SENT_READ },
  component: RouteComponent,
})

withRoutePermissions(Route)

function RouteComponent() {
  const [exportOpen, setExportOpen] = useState(false)
  const [relaunchOpen, setRelaunchOpen] = useState(false)

  return (
    <>
      <AppHeader>
        <Title>Suivis des SMS - Publication du planning</Title>
      </AppHeader>
      <AppContainer>
        <div className="flex justify-between items-start">
          <div className="flex flex-col justify-center items-start gap-4 font-sans text-black">
            <p className="text-xl leading-normal text-black/80">
              Chaque SMS contient un lien unique vers la page planning. Le statut “Lu” est
              enregistré quand le destinataire ouvre ce lien
            </p>
          </div>
          <div className="flex justify-end items-start gap-2">
            <AuthorizedAppButton
              permission={SMS_SENT_EXPORT}
              variant="outline"
              className="bg-transparent"
              onClick={() => setExportOpen(true)}
            >
              Exporter CSV
            </AuthorizedAppButton>
            <AuthorizedAppButton permission={SMS_RESEND} onClick={() => setRelaunchOpen(true)}>
              Relancer les non-lus
            </AuthorizedAppButton>
          </div>
        </div>
        <SmsTrackingPage />
        <SmsTrackingExportDialog open={exportOpen} onOpenChange={setExportOpen} />
        <SmsTrackingRelaunchDialog open={relaunchOpen} onOpenChange={setRelaunchOpen} />
      </AppContainer>
    </>
  )
}
